import { AxisValues } from '../../../../common/utils/enum'
import {
  clone,
  getBadges,
  getRecentYearRange,
} from '../../../../common/utils/helper'

export const getChartTitle = (indicatorName) => {
  return {
    useHTML: true,
    text: `<h2 style="font-size: 24px;font-style: normal;font-weight: 700;line-height: 28px;color: rgba(0, 0, 0, 0.87);">${
      indicatorName ?? ''
    }</h2>`,
    align: 'left',
  }
}

export const getSingleYearChartSubtitle = (
  selectedCountries,
  countriesData,
  year
) => {
  const countries = selectedCountries
    .map(
      (selectedCountry) =>
        countriesData.find(
          (country) =>
            country.id.toUpperCase() === selectedCountry.toUpperCase()
        )?.name
    )
    .filter(Boolean)
  return countries.length > 0
    ? year
      ? `${countries.join(', ')}, ${year}`
      : countries.join(', ')
    : year
    ? year
    : ''
}

export const getBarChartSubtitle = ({
  selectedCountriesForBar,
  disaggregationCountries,
  selectedSingleYear,
  recentYearSelection,
  filteredIndicatorData,
}) => {
  const countries =
    selectedCountriesForBar[0] === 'all'
      ? ['All countries']
      : selectedCountriesForBar &&
        selectedCountriesForBar.map(
          (selectedCountry) =>
            disaggregationCountries.find(
              (country) =>
                country.id.toLowerCase() === selectedCountry.toLowerCase()
            )?.name
        )
  const formattedCountries = countries && countries.join(', ')
  const subtitle = formattedCountries
    ? selectedSingleYear
      ? `${formattedCountries}, ${
          recentYearSelection
            ? `Most recent values ${getRecentYearRange(filteredIndicatorData)}`
            : selectedSingleYear
        }`
      : formattedCountries
    : selectedSingleYear
    ? `${
        recentYearSelection
          ? `Most Recent Values ${getRecentYearRange(filteredIndicatorData)}`
          : selectedSingleYear
      }`
    : ''
  return subtitle
}

export const getChartBadges = (
  selectedFilters,
  disaggregationData,
  selectedComparison,
  unitMeasureName
) => {
  const badges = getBadges(
    selectedFilters,
    disaggregationData,
    selectedComparison,
    unitMeasureName
  )
  return badges && badges.length > 0
    ? badges.map((badge) => (
        <div key={badge} className="text tui_badge">
          <div>
            <p>{badge}</p>
          </div>
        </div>
      ))
    : ''
}

export const getBarChartSubtitleForExport = ({
  selectedCountriesForBar,
  disaggregationCountries,
  selectedSingleYear,
  recentYearSelection,
  filteredIndicatorData,
  selectedFilters,
  disaggregationData,
  selectedComparison,
  unitMeasureName,
}) => {
  const subtitle = getBarChartSubtitle({
    selectedCountriesForBar,
    disaggregationCountries,
    selectedSingleYear,
    recentYearSelection,
    filteredIndicatorData,
  })
  const badges = getBadges(
    selectedFilters,
    disaggregationData,
    selectedComparison,
    unitMeasureName
  )

  let badgesDiv =
    badges && badges.length > 0
      ? badges.map(
          (badge) =>
            `<div class="text tui_badge" style="font-size: 0.8125rem;font-weight: 600;line-height: 1.0625rem;text-transform: uppercase;border-radius: 2px;background: #F4F5F7;border: 1px solid #CED4DE;color: #535B6A;padding: 4px 10px;">
      <div>
        <p>${badge}</p>
      </div>
    </div>`
        )
      : []
  badgesDiv = badgesDiv.join(' ')
  return {
    useHTML: true,
    text: `<p class="tui__text_base">${subtitle}</p><br/>
    <div class="tui__badge_container" style="margin: 0 0 -1rem;display: flex;align-items: center;flex-wrap: wrap;">
      <div class="tui_badge_group" style="display: flex;align-items: center;flex-wrap: wrap;">
          ${badgesDiv}
      </div>
    </div>
  `,
    align: 'left',
  }
}

// Function to find the first available value from the end
export const findFirstAvailableValueFromEnd = (seriesData) => {
  for (let i = seriesData.length - 1; i >= 0; i--) {
    if (seriesData[i].y !== null) {
      return seriesData[i]
    }
  }
  return null // Return null if no available value is found
}

export const getMinorGridlinesForLogAxis = (axisTicks) => {
  let finalTicks = clone(axisTicks)
  axisTicks.forEach((item, index) => {
    if (index === axisTicks.length - 1) return
    const interval = axisTicks[index + 1] - item
    let steps = 4 // will add 3 intermediate minor ticks/gridlines
    let values = Array.from(
      { length: steps },
      (_, i) => item + (interval / steps) * i
    )
    values.shift()
    finalTicks = [...finalTicks, ...values]
  })
  return finalTicks
}

export const getColorForCorrelation = (
  d,
  axisValues,
  axisValuesParams,
  defaultColor,
  alternateColor
) => {
  let color = defaultColor

  if (axisValues === AxisValues.Logarithmic) {
    color = Math.log(d) % 1 === 0 ? defaultColor : alternateColor
  } else if (
    axisValues === AxisValues.Exponential &&
    (!axisValuesParams || axisValuesParams === '10')
  ) {
    color = Math.log10(d) % 1 === 0 ? defaultColor : alternateColor
  } else if (
    axisValues === AxisValues.Exponential &&
    axisValuesParams &&
    axisValuesParams === '2'
  ) {
    color = Math.log2(d) % 1 === 0 ? defaultColor : alternateColor
  } else if (
    axisValues === AxisValues.Exponential &&
    axisValuesParams &&
    axisValuesParams !== '10' &&
    axisValuesParams !== '2'
  ) {
    color =
      (Math.log(d) / Math.log(Number(axisValuesParams))) % 1 === 0
        ? defaultColor
        : alternateColor
  }
  return color
}
